import type { GridValueGetterParams } from '@mui/x-data-grid-pro'

export function getLoad(params: GridValueGetterParams<uui.domain.client.rm.FormattedData>) {
  const loads = params.row.loads
  const loadName = params.field.replace('formattedData.loads.', '')

  return loads[loadName] ? loads[loadName] / 100 : '-'
}
